import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, UserRoles, DataListModel } from '../../shared/config';
import { PersonModel } from '../../person/models/person.model';
import { OrganizationService } from '../models/organization.service';

@Component({
    selector: 'wego-organization-contact-person',
    template: require('../views/organization-contact-popup.component.html'),
})

export class OrganizationContactPopupComponent implements OnInit, OnChanges {
    DataListModel: DataListModel;
    personList: PersonModel[];
    message: string;
    apiErrorMsg: string;
    urlPersonUpdate: string;
    isLoading: boolean;

    public organizationMasterHashId: string;
    @Output('OnSuccessSelect') onSuccessSelect = new EventEmitter();
    @ViewChild('contactPersonModal') public contactPersonModal: any;

    constructor(private organizationService: OrganizationService
        , private authService: AuthService
        , private router: Router) { }

    ngOnInit() {
        this.DataListModel = new DataListModel();
        this.DataListModel.searchField = ["userName", "firstName", "lastName"];
        this.urlPersonUpdate = this.authService.GetURL(ApplicationRouteURL.URL_PERSON_UPDATE);
    }

    ngOnChanges(change: any) {
        console.log(change);
    }

    public show(): void {
        this.DataListModel.currentPage = 1;
        this.DataListModel.totalItems = 0;
        this.DataListModel.sortType = "";
        this.DataListModel.sortReverse = null;
        this.DataListModel.searchTerm = "";
        this.DataListModel.infoMessage = "";
        this.GetContactPersonList();
        this.contactPersonModal.show();
    }

    public hide(): void {
        this.contactPersonModal.hide();
    }

    private GetContactPersonList() {
        this.isLoading = true;
        this.organizationService.GetPersonListForContactPerson(this.organizationMasterHashId, this.DataListModel)
            .subscribe(
            res => {
                this.personList = res.data;
                this.DataListModel.totalItems = res.totalRecords;
                this.DataListModel.infoMessage = res.error;
                this.isLoading = false;
            },
            error => {
                this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
                this.isLoading = false;
            });
    }

    private select(hashId: string): void {
        this.isLoading = true;
        this.organizationService.UpdateOrganizationContactPerson(this.organizationMasterHashId, hashId)
            .subscribe(
            res => {
                this.message = "Record Saved successfully.";
                this.OnSuccessSelect();
                this.isLoading = false;
            },
            error => {
                this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
                this.isLoading = false;
            },
            () => {
                this.contactPersonModal.hide();
                this.isLoading = false;
            });
    }

    private OnSort(sortName: string) {
        this.DataListModel.sortType = sortName;
        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
        this.GetContactPersonList();
    }

    private OnSearch(event: any) {
        this.DataListModel.searchTerm = event.searchTerm;
        this.DataListModel.currentPage = 1;
        this.GetContactPersonList();
    }

    private OnPageChanged(event: any): void {
        this.DataListModel.currentPage = event.page;
        this.GetContactPersonList();
    };

    private OnPagingChange(event: any) {
        this.DataListModel.currentPage = 1;
        this.DataListModel.totalItems = 0;
        this.DataListModel.itemsPerPage = event.itemPerPage;
        this.GetContactPersonList();
    }
    private OnSuccessSelect() {
        this.onSuccessSelect.emit({ SuccessMessage: this.message })
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/organization/components/organization-contact-popup.component.ts